document.getElementById("friends_btn_id").addEventListener("click", function (e) {
    e.preventDefault();

    const btn = this;

    navigator.clipboard.writeText(window.location.href).then(() => {
        const originalText = btn.textContent;
        btn.textContent = "Copied!";

        setTimeout(() => {
            btn.textContent = originalText;
        }, 2000);
    });
}); 